import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

interface DialogProps {
  children: React.ReactNode;
  onClose: () => void;
  className?: string;
}

export const Dialog: React.FC<DialogProps> = ({ children, onClose, className = '' }) => {
  // Handle ESC key
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [onClose]);

  // Prevent body scroll when dialog is open
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return createPortal(
    <div 
      className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center p-4 z-50 overflow-y-auto"
      onClick={handleBackdropClick}
      role="dialog"
      aria-modal="true"
    >
      <div 
        className={`bg-white rounded-lg shadow-xl relative ${className}`}
        onClick={e => e.stopPropagation()}
      >
        <div className="p-6">
          {children}
        </div>
      </div>
    </div>,
    document.body
  );
};